import { Button, CircularProgress, Switch } from "@mui/material";
import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import axios from "../../axios/axios";
import { toast } from "react-toastify";
import { useContext } from "react";
import { AuthenticationContext } from "../../App";
import { API } from "../../common/Constants";
const Login = () => {
    const DealerLoggedData = JSON.parse(localStorage.getItem("DealerLoggedData"));
    const { setAuthData } = useContext(AuthenticationContext);
    const [userType, setUserType] = useState(true);
    const [resetPwd, setresetPwd] = useState(false);
    const [resetLinkMsg, setresetLinkMsg] = useState(false);
    const navigate = useNavigate();
    const location = useLocation();
    const [errMsg, setErrMsg] = useState({
        email: false,
        pwd: false,
        rememberMe: false,
    });
    const [formInput, setFormInput] = useState({
        email: "",
        password: "",
        rememberMe: false,

    });
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (
            DealerLoggedData !== null &&
            DealerLoggedData !== undefined &&
            Object.keys(DealerLoggedData)?.length > 0
        ) {
            setFormInput(DealerLoggedData);
        } else {
            setFormInput({
                email: "",
                password: "",
                rememberMe: false,
            });
        }
    }, []);

    const handleLogin = async (e) => {
        e.preventDefault();
        let emailRegx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!emailRegx.test(formInput.email)) {
            setErrMsg({ ...errMsg, email: true, pwd: false });
        } else if (formInput.password < 8) {
            setErrMsg({ ...errMsg, pwd: true, email: false });
        } else {
            setErrMsg({ ...errMsg, active: false });
            setLoading(true);
            const resp = await axios
                .post("/login", {
                    email: formInput.email,
                    password: formInput.password,
                })
                .then((data) => {
                    const respCode = data?.data?.resp_code;
                    const token = data?.data?.data?.token;
                    localStorage.setItem("dealerModuleToken", token);
                    if (formInput?.rememberMe) {
                        localStorage.setItem("DealerLoggedData", JSON.stringify(formInput));
                    } else {
                        localStorage.removeItem("DealerLoggedData");
                    }
                    if (respCode === 200) {
                        setAuthData(data?.data?.data);
                        const params = new URLSearchParams(location.search);
                        const redirectPath = params.get("redirect");
                        if (redirectPath) {
                            navigate(decodeURIComponent(redirectPath));
                        } else {
                            navigate("/");
                        }
                    }
                    setLoading(false);
                })
                .catch((err) => {
                    toast.error("Invalid Credentials");
                    setLoading(false);
                });
        }
    };
    const handlePwdLink = async () => {
        let emailRegx = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!emailRegx.test(formInput.email)) {
            setErrMsg({ ...errMsg, email: true, pwd: false });
        } else {
            const resp = await axios
                .post("/forgot/password", { email: formInput.email })
                .then((resp) => {
                    if (resp.status < 400) {
 
                        toast.success(resp.data?.message);
                        setresetLinkMsg(true);
                    }
                })
                .catch((err) => {
                    console.log(err?.response?.status);
                    const respCode = err?.response?.status;
                    if (respCode === 401) {
                        toast.error("Entered email is Not Registered");
                    }
                });
        }
    };
    useEffect(() => {
        const tokenId = localStorage.getItem("dealerModuleToken");
        if (tokenId) {
            navigate("/");
        }
    }, []);
    return (
        <div className="login_page select-none">
            <div className="img_flx_sec">
                <img src="/images/login_bg.png" alt="login page" />
                <div className="img_shadow"></div>
                <div className="content_sec">
                    <h1 className="login_head_text">Discover, Collaborate, Win</h1>
                    <p className="sub_para">
                        Discover customer pain points, Collaborate to achieve those using
                        OhhTo and get more bonus and get customers.{" "}
                        <Link className="font-[500] underline underline-offset-4">
                            View More..
                        </Link>
                    </p>
                </div>
            </div>
            <div className="cont_flx_sec">
                <div className="log_box">
                    <div className="mb-[22px]">
                        <img src="/images/site_logo2.png" alt="site logo" />
                    </div>
                    <h2 className="heading">Hi, Welcome Back</h2>
                    <p className="sub_heading">to the new auto portal.</p>
                    {!resetPwd && (
                        <div className="switch_box">
                            <label className="">Select user type</label>
                            <div className="switcher">
                                <span
                                    className={`chg_tab ${userType && "active"}`}
                                    onClick={() => setUserType(!userType)}
                                >
                                    Dealer
                                </span>
                                <Link
                                    to={`${API.webUrl}agent/login`}
                                    // action={`${API}/login`}
                                    className={`chg_tab ${!userType && "active"}`}
                                    onClick={() => setUserType(!userType)}
                                >
                                    Agent
                                </Link>
                            </div>
                        </div>
                    )}
                    {resetLinkMsg ? (
                        <div className="py-[30px] text-center">
                            <p className="font-[500] mb-[8px]">
                                Reset password link sent successfully!!
                            </p>
                            <p className="font-[500] mb-[8px]">
                                Please Check Your Email{" "}
                                <span className="border-b border-slate-600">
                                    {formInput.email}
                                </span>
                            </p>
                        </div>
                    ) : (
                        <form
                            className={`${resetPwd && "py-[30px]"}`}
                            onSubmit={handleLogin}
                        >
                            <div className="form_control">
                                <label
                                    className="justify-between items-center"
                                    style={{ display: "flex" }}
                                >
                                    Email Address
                                    <span
                                        className={`font-[500] text-[13px] text-[red] ${!errMsg.email && "hidden"
                                            }`}
                                    >
                                        Invalid Email
                                    </span>
                                </label>
                                <div className="input_box relative">
                                    <div className="placeholder_icon">
                                        <img src="/images/fi_mail.svg" alt="placeholde icon" />
                                    </div>
                                    <input
                                        type="text"
                                        placeholder="johndoe@workemail.com"
                                        value={formInput.email}
                                        onChange={(e) =>
                                            setFormInput({ ...formInput, email: e.target.value })
                                        }
                                    />
                                </div>
                            </div>
                            {!resetPwd && (
                                <div className="form_control">
                                    <label
                                        className="justify-between items-center"
                                        style={{ display: "flex" }}
                                    >
                                        Password
                                        <span
                                            className={`font-[500] text-[13px] text-[red] ${!errMsg.pwd && "hidden"
                                                }`}
                                        >
                                            Invalid Password
                                        </span>
                                    </label>
                                    <div className="input_box relative">
                                        <div className="placeholder_icon">
                                            <img src="/images/fi_lock.svg" alt="placeholde icon" />
                                        </div>
                                        <input
                                            type="password"
                                            placeholder="8+ Character required"
                                            value={formInput.password}
                                            onChange={(e) =>
                                                setFormInput({ ...formInput, password: e.target.value })
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                            {!resetPwd && (
                                <div className="flex items-center justify-between mb-[20px]">
                                    <div className="text-[#3D3D3D] font-[500]">
                                        <Switch
                                            checked={formInput.rememberMe}
                                            onClick={() => {
                                                setFormInput({
                                                    ...formInput,
                                                    rememberMe: !formInput.rememberMe,
                                                });
                                            }}
                                        />
                                        Keep me login
                                    </div>
                                    <div
                                        className="text-[#0560FB] font-[500] cursor-pointer"
                                        onClick={() => setresetPwd(true)}
                                    >
                                        Forgot password?
                                    </div>
                                </div>
                            )}
                            {!resetPwd ? (
                                <Button type="submit" className="submit_btn" disabled={loading}>
                                    {loading && (
                                        <CircularProgress
                                            size={20}
                                            style={{ color: "white" }}
                                            className="mr-[13px]"
                                        />
                                    )}
                                    Login
                                </Button>
                            ) : (
                                <Button
                                    type="button"
                                    className="submit_btn"
                                    onClick={handlePwdLink}
                                >
                                    Get Password Link
                                </Button>
                            )}
                        </form>
                    )}
                    <div className="mt-[20px] text-[#747587] text-[13px] text-center">
                        Copyright © ohhto.io. All Rights Reserved
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Login;
